export default function AcademyAdminiPhoneChrome({ style }) {
  return (
    <svg
      width="417"
      height="848"
      viewBox="0 0 417 848"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style || {}}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61 5H356C388 5 409 26 409 58V790C409 822 388 843 356 843H61C29 843 8 822 8 790V58C8 26 29 5 61 5Z"
        fill="#000000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M356 0H61C43.8837 0 29.2907 5.6382 18.9645 15.9645C8.6382 26.2907 3 40.8837 3 58V110C1.34315 110 0 111.343 0 113V139C0 140.657 1.34315 142 3 142V172C1.34315 172 0 173.343 0 175V231C0 232.657 1.34315 234 3 234V250C1.34315 250 0 251.343 0 253V309C0 310.657 1.34315 312 3 312V790C3 807.116 8.6382 821.709 18.9645 832.036C29.2907 842.362 43.8837 848 61 848H356C373.116 848 387.709 842.362 398.036 832.036C408.362 821.709 414 807.116 414 790V292C415.657 292 417 290.657 417 289V195C417 193.343 415.657 192 414 192V58C414 40.8837 408.362 26.2907 398.036 15.9645C387.709 5.6382 373.116 0 356 0ZM61 5H356C388 5 409 26 409 58V790C409 822 388 843 356 843H61C29 843 8 822 8 790V58C8 26 29 5 61 5Z"
        fill="#AABBCC"
      />
    </svg>
  );
}
